export default __webpack_public_path__ + "static/media/left.3e26391e.svg";